import React, { useEffect, useState } from "react";
import { classNames } from "@greeter/util";

import css from "./DangerText.module.scss";

const DangerText: React.FC<React.HTMLProps<HTMLSpanElement>> = ({ className, ...props }) => (
    <span {...props} {...classNames(className, css.DangerText)} />
);


export default DangerText;
